import { Component, OnInit } from '@angular/core';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { RevenueReportService } from 'src/app/services/revenue-report.service';

@Component({
  selector: 'app-revenue-report',
  templateUrl: './revenue-report.component.html',
  styleUrls: ['./revenue-report.component.css']
})
export class RevenueReportComponent implements OnInit {
  inputDateFrom: number;
  inputDateTo: number;
  timeSelected = 'LAST-7-DAYS';
  loading = false;
  report: { totalPrice: number, totalCost: number, revenue: number, count: number } | null = null;

  constructor(private revenueService: RevenueReportService) { }

  ngOnInit(): void {
    // default last 7 days
    this.setTimePeriode('LAST-7-DAYS');
  }

  setTimePeriode(value) {
    const now = moment();
    let from, to;
    switch (value) {
      case 'TODAY':
        from = moment(now).startOf('day').unix();
        to = now.endOf('day').unix();
        break;
      case 'LAST-7-DAYS':
        from = moment(now).subtract(7, 'days').startOf('day').unix();
        to = moment(now).endOf('day').unix();
        break;
      case 'THIS_MONTH':
        from = moment(now).startOf('month').unix();
        to = moment(now).endOf('day').unix();
        break;
      case 'LAST_MONTH':
        from = moment(now).subtract(1, 'month').startOf('month').unix();
        to = moment(now).subtract(1, 'month').endOf('month').unix();
        break;
      case 'CUSTOM':
        return;
    }
    this.inputDateFrom = from;
    this.inputDateTo = to;
  }

  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {
    if (picker === 'start') {
      this.inputDateFrom = moment(event.value).startOf('day').unix();
    } else {
      this.inputDateTo = moment(event.value).endOf('day').unix();
    }
  }

  async onSubmit() {
    this.loading = true;
    try {
      const res = await this.revenueService.getRevenue(this.inputDateFrom, this.inputDateTo).toPromise();
      if (res && res.success) {
        this.report = {
          totalPrice: res.totalPrice,
          totalCost: res.totalCost,
          revenue: res.revenue,
          count: res.count
        };
      } else {
        this.report = null;
      }
    } catch (err) {
      console.error(err);
      this.report = null;
    }
    this.loading = false;
  }
}
